export default Object.freeze({
  singleSelection: 1,
  multiSelection: 2,
  spinner: 3,
  weight: 4,
  draggableScale: 7,
  textInput: 8,
  image: 10
});
